import { useSupplementStore } from '../stores/supplementStore';
import type { SupplementArm } from '../types/supplement';
import { toSupplementArm } from '../utils/supplement';

export function useSupplementArm(): SupplementArm {
  const store = useSupplementStore();

  if (import.meta.client && store.arm === null) {
    const { getVariation } = useGrowthBook();
    store.arm = toSupplementArm(getVariation<unknown>(EXPERIMENTS.SUPPLEMENTS, null));
  }

  return toSupplementArm(store.arm);
}
